import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// 브라우저 자동 번역의 DOM 조작으로부터 React 커밋을 보호 — 렌더 전에 설치한다
import { installDomTranslationGuard } from '@/lib/domTranslationGuard'
// i18n은 스토어/API 모듈보다 먼저 초기화되어야 한다 (모듈 평가 시점에 i18n.t 사용)
import '@/i18n'
import App from './App.tsx'
import '@/styles/globals.css'
import { installErrorReporter } from '@/lib/errorReporter'

installDomTranslationGuard()
// 초기 마운트 크래시까지 잡도록 렌더 전에 설치
installErrorReporter()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
